<template>
  <div class="trial">
    <div class="trial-on">
      <div class="head">
        <router-link to="/">
          <img src="./img/logo.png" alt />
        </router-link>
      </div>
      <div class="apply">
        <p class="title">申请试用</p>
        <div class="query-item">
          <span>学校名称</span>
          <Input class="input" size="large" v-model="query.schoolName" />
        </div>
        <div class="query-item">
          <span>您的姓名</span>
          <Input class="input" size="large" v-model="query.userName" />
        </div>
        <div class="query-item">
          <span>您的职务</span>
          <Input class="input" size="large" v-model="query.userJob" />
        </div>
        <div class="query-item">
          <span>联系方式</span>
          <Input class="input" size="large" v-model="query.phone" />
        </div>
        <div class="query-item">
          <span style="visibility: hidden;">联系方式</span>
          <Button
            size="large"
            class="input"
            type="success"
            :loading="loading"
            @click="submission"
          >
            提交
          </Button>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import foot from "@/components/foot/foot";
import { addOfficialTrialOrders } from "@/api/request";

export default {
  name: "trial",
  data() {
    return {
      query: {
        schoolName: "",
        userName: "",
        userJob: "",
        phone: ""
      },
      loading: false
    };
  },
  methods: {
    submission() {
      if (this.query.schoolName === "") {
        this.$Message.error("请填写学校名称");
        return false;
      }
      if (this.query.userName === "") {
        this.$Message.error("请填写您的姓名");
        return false;
      }
      if (this.query.userJob === "") {
        this.$Message.error("请填写您的职务");
        return false;
      }
      if (this.query.phone === "") {
        this.$Message.error("请填写联系方式");
        return false;
      } else {
        let reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
        if (!reg.test(this.query.phone)) {
          this.$Message.error("请输入正确电话号码");
          return false;
        }
      }
      this.loading = true;

      addOfficialTrialOrders({
        type: 1,
        ...this.query
      }).then(data => {
        if (!data) {
          this.$Message.success("提交成功");
          setTimeout(() => {
            this.loading = false;
          }, 500);
        }
      })
    }
  },
  components: {
    foot
  }
};
</script>

<style lang="less" scoped>
.trial-on {
  background-image: url(./img/u2773.jpg);
  background-repeat: round;
  width: 100%;
  position: relative;
  // padding-bottom: 0.65rem;
  height: 88vh;
  .head {
    height: 1rem;
    border-bottom: 0.01rem solid rgba(121, 121, 121, 1);
    img {
      height: 0.8rem;
      margin: 0.1rem 1rem;
    }
  }
  .apply {
    width: 5.5rem;
    height: 4.8rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.16rem;
    margin: 0.3rem auto 0.1rem;
    text-align: center;
    .title {
      font-weight: 600;
      color: rgba(34, 34, 34, 1);
      font-size: 0.36rem;
      padding: 0.4rem;
    }
    .query-item {
      margin-bottom: 0.2rem;
      span {
        font-size: 0.16rem;
        font-weight: 500;
        color: rgba(34, 34, 34, 1);
        vertical-align: middle;
        padding-right: 0.14rem;
      }
      .input {
        width: 2.7rem;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .title {
    padding: 0.2rem !important;
  }
}
@media screen and (max-width: 900px) {
  .query-item {
    .input {
      height: 0.5rem !important;
      line-height: 0.5rem;
      /deep/input {
        height: 0.5rem !important;
        font-size: 0.25rem;
      }
      /deep/span {
        font-size: 0.3rem;
      }
    }
  }
}
</style>
